/*! Lazy Image (lightweight, no Custom Elements polyfill) */
(function () {
  function shouldHandle(img) {
    if (!img || img.nodeName !== "IMG") return false;
    if (img.getAttribute("is") !== "lazy-image") return false;
    return true;
  }

  function isHiddenByBreakpoint(img) {
    var mql = window.matchMedia("(min-width: 750px)");
    if (mql.matches && img.classList.contains("medium-hide")) return true;
    if (!mql.matches && img.classList.contains("small-hide")) return true;
    return false;
  }

  function markLoaded(img, wrapper) {
    var done = function () {
      img.classList.add("loaded");
      if (wrapper) wrapper.classList.remove("loading");
    };
    if (window.requestIdleCallback) window.requestIdleCallback(done, { timeout: 150 });
    else setTimeout(done, 0);
  }

  function attach(img) {
    if (!shouldHandle(img)) return;
    if (img.__lazyImageHandled) return;
    img.__lazyImageHandled = true;

    var wrapper = img.closest(".media-wrapper");
    if (!wrapper) return;

    function handle() {
      if (isHiddenByBreakpoint(img)) return;
      if (img.complete || img.classList.contains("loaded")) return;
      wrapper.classList.add("loading");
    }

    handle();
    window.addEventListener("resize", handle, true);

    img.addEventListener(
      "load",
      function () {
        markLoaded(img, wrapper);
      },
      { once: true }
    );

    // If src/srcset changes after initial render
    var mo = new MutationObserver(function (changes) {
      for (var i = 0; i < changes.length; i++) {
        var name = changes[i].attributeName || "";
        if (name.indexOf("src") !== -1) {
          img.__lazyImageHandled = false;
          attach(img);
          return;
        }
      }
    });
    mo.observe(img, { attributes: true, attributeFilter: ["src", "srcset"] });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll('img[is="lazy-image"]');
    for (var i = 0; i < imgs.length; i++) attach(imgs[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  // Watch for dynamically inserted images
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      if (!nodes) continue;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (!node || !node.querySelectorAll) continue;
        scan(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
